module.exports = __webpack_public_path__ + "img/bg.219cd50d.png";